/**
 * @param {string | undefined} [className]
 * @returns {React.ReactElement}
 */
const CompanyLogoGIJPMobile = ({ className }) => (
  <svg
    version="1.1"
    width="60px"
    height="intrinsic"
    className={className}
    x="0px"
    y="0px"
    viewBox="0 0 102.199 68.351"
    enableBackground="new 0 0 102.199 68.351"
  >
    <g id="Icon_x5F_klein">
      <polygon
        fill="#002967"
        points="13.806,68.351 13.806,53.67 31.04,53.871 	"
      />
      <path
        fill="#002967"
        d="M93.695,54.439H8.504C3.807,54.439,0,50.631,0,45.935V8.504C0,3.807,3.807,0,8.504,0h85.191
		c4.697,0,8.504,3.807,8.504,8.504v37.431C102.199,50.631,98.392,54.439,93.695,54.439z"
      />
      <g id="stay">
        <path
          fill="#F1AA00"
          d="M30.215,34.976c0,5.083-4.033,6.889-8.99,6.889c-3.486,0-6.889-1.008-9.242-2.562l1.933-4.411
			c2.353,1.302,4.831,2.017,7.646,2.017c2.268,0,2.94-0.546,2.94-1.681c0-1.008-0.798-1.512-3.235-2.226
			c-5.293-1.596-8.695-2.898-8.695-7.562c0-4.579,3.655-6.553,8.822-6.553c2.772,0,5.797,0.84,8.149,2.143l-1.849,4.579
			c-2.184-1.176-4.579-1.764-6.427-1.764c-2.352,0-2.982,0.462-2.982,1.428c0,0.924,0.672,1.302,4.579,2.562
			C26.812,29.137,30.215,30.565,30.215,34.976z"
        />
        <path
          fill="#F1AA00"
          d="M46.699,34.64l-0.84,5.881c-0.966,0.756-2.688,1.344-4.495,1.344c-3.571,0-5.881-2.772-5.881-6.637V24.81
			h-3.697v-5.461h3.697v-5.671l5.797-2.898v8.57h5.293v5.461H41.28v8.863c0,2.101,0.756,2.646,2.142,2.646
			C44.472,36.32,45.271,35.858,46.699,34.64z"
        />
        <path
          fill="#F1AA00"
          d="M68.068,41.403h-5.797v-1.47c-1.05,1.092-2.898,1.932-4.957,1.932c-4.117,0-8.233-2.521-8.233-7.855
			c0-4.873,3.949-7.309,8.948-7.309c2.016,0,3.318,0.42,4.243,0.882V26.49c0-1.554-1.05-2.814-3.15-2.814
			c-2.646,0-4.033,0.378-6.049,1.47l-2.226-4.033c2.562-1.47,4.705-2.227,8.275-2.227c5.335,0,8.947,2.772,8.947,7.729V41.403z
			 M62.271,34.934v-2.772c-1.008-0.63-1.974-0.924-4.033-0.924c-2.184,0-3.36,1.008-3.36,2.772c0,1.555,0.882,2.941,3.36,2.941
			C60.129,36.95,61.642,35.984,62.271,34.934z"
        />
        <path
          fill="#F1AA00"
          d="M91.845,19.349L80.503,49.174H74.79l2.94-7.771l-8.569-22.054h6.385l3.612,10.628
			c0.588,1.68,1.176,3.78,1.428,4.831c0.252-1.092,0.84-3.108,1.428-4.831l3.613-10.628H91.845z"
        />
      </g>
    </g>
    <g id="Icon_x5F_groß_x5F_blau_x5F_vektor"></g>
    <g id="Icon_x5F_groß_x5F_blau_x5F_font"></g>
  </svg>
);

export default CompanyLogoGIJPMobile;
